module.exports = __webpack_public_path__ + "img/thumbnail_BlackWhiteRuffedLemur_j_normal.4c320af5.png";